export const HOMEPAGE_DRAFT_PATH = '/homepage-draft';

export const HOMEPAGE_DRAFT_SEO = {
  title: 'Лицензии на российские и зарубежные IT и AI решения | Антология',
  description:
    'Подберём лицензии на ПО для бизнеса под задачу и бюджет. Оплата в рублях, закрывающие документы, помощь с внедрением.',
};

export const HOMEPAGE_DRAFT_HERO = {
  titleStart: 'Лицензии на ПО для бизнеса в одном окне',
  titleEnd: '- удобно, в рублях, с закрывающими документами',
  subtitle: 'Подберём ИТ-решения под ваши задачи и бюджет. Поможем оплатить и внедрить.',
  cta: 'Подобрать решение',
};

export const HOMEPAGE_DRAFT_CATALOG = [
  {
    title: 'Популярное ПО для бизнеса',
    description:
      'Подберём лицензии под задачу. Оплата со счёта компании в рублях, с закрывающими документами.',
    href: '/solutions',
  },
  {
    title: 'Решения на базе ИИ',
    description:
      'Лицензии на AI-продукты в облаке или с установкой у вас. Настроим и внедрим, поддержка по SLA.',
    href: '/catalog/avtomatizachiya_biznessa/ai_instrumenty',
  },
  {
    title: 'Интеграция и поддержка под ключ',
    description:
      'Встроим продукт в вашу инфраструктуру, настроим и обучим сотрудников. Дальше поддержка по SLA.',
    href: '/enterprise-systems',
  },
];

export const HOMEPAGE_DRAFT_TASKS = [
  'Автоматизировать бизнес-процессы',
  'Увеличить конверсию отдела продаж и средний чек',
  'Настроить ИТ-инфраструктуру в команде',
  'Повысить лояльность и удержание клиентов',
  'Усилить креативную команду',
  'Ускорить создание контента',
  'Автоматизировать техподдержку',
  'Контролировать показатели бизнеса',
  'Автоматизировать бухгалтерский учет',
  'Защитить данные и снизить киберриски',
  'Оптимизировать затраты на персонал',
  'Ускорить процесс найма',
  'Упростить онбординг новых сотрудников',
];

export const HOMEPAGE_DRAFT_SOLUTIONS = [
  'Gen AI Infrastructure',
  'Just AI Copilot',
  'AI для отдела продаж',
  'ERP + ИИ-агенты',
];

export const HOMEPAGE_LEAD_SUCCESS = {
  title: 'Заявка отправлена',
  text: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
};
